// config.ts - configuration Firebase web (clés publiques, non secrètes).
// La config web Firebase est publique par conception (sécurité assurée par les
// Firestore Rules + App Check, pas par le secret de l'apiKey).
//
// Deux applications web sont enregistrées dans le MÊME projet Firebase `hop-resto` :
//  - Public   → landing + PWA restaurateur
//  - Admin    → back-office (exécuté en local uniquement)

export interface FirebaseWebConfig {
  apiKey: string;
  authDomain: string;
  projectId: string;
  storageBucket: string;
  messagingSenderId: string;
  appId: string;
  measurementId?: string;
}

export const FIREBASE_PROJECT_ID = 'hop-resto';

/**
 * Clés publiques **Web Push (VAPID)** - notifications de la PWA restaurateur
 * (docs/rules/notifications-resto.md). Publiques par conception, comme le
 * reste de cette configuration : c'est la moitié PUBLIQUE d'une paire, la
 * moitié privée ne quitte jamais Firebase.
 *
 * À récupérer une fois par projet dans la console Firebase :
 * **Paramètres du projet → Cloud Messaging → Configuration Web →
 * Certificats push Web → Générer une paire de clés**, puis coller la valeur
 * (« Clé publique », ~87 caractères commençant par `B`) ci-dessous.
 *
 * Tant qu'une clé est vide, les notifications sont simplement **indisponibles**
 * sur la surface concernée : l'app le dit dans Paramètres et ne casse rien
 * (l'alerte sonore, elle, fonctionne sans aucune clé).
 */
export const VAPID_KEY_PROD =
  'BOFdNjyAPc_n3maY3cy3O2W4pZ5unjP_RCabbzAKD8UZeUDoVVVbp4Ddei6VrlXkqf6dzRjOjiRRIzGavi1VBUs';
export const VAPID_KEY_DEV =
  'BFVCDEsLzQhQgOcsR1MgARwIP7SWk1j3-kt85ejIyNIVhLnAAOD7myRHoLWYaxrE_h4aiVkOryclzRwHfEAN6jU';

/** App web publique : landing + PWA restaurateur. */
export const firebaseConfigPublic: FirebaseWebConfig = {
  apiKey: 'AIzaSyBxOhpwYrDn0lJoNLMaarInGC2iKG-rWos',
  authDomain: 'hop-resto.firebaseapp.com',
  projectId: 'hop-resto',
  storageBucket: 'hop-resto.firebasestorage.app',
  messagingSenderId: '971760780175',
  appId: '1:971760780175:web:824f7901faa7f20fea41fa',
  measurementId: 'G-106JZH194M',
};

/** App web PWA restaurateur (Firebase Hosting, site dédié). */
export const firebaseConfigPwa: FirebaseWebConfig = {
  apiKey: 'AIzaSyBxOhpwYrDn0lJoNLMaarInGC2iKG-rWos',
  authDomain: 'hop-resto.firebaseapp.com',
  projectId: 'hop-resto',
  storageBucket: 'hop-resto.firebasestorage.app',
  messagingSenderId: '971760780175',
  appId: '1:971760780175:web:e372c05c5b5cc74cea41fa',
  measurementId: 'G-P0CJGKXYNL',
};

/**
 * Projet DEV (hop-resto-dev) - backend d'intégration : Firestore/Auth/Functions
 * isolés de la prod. Une seule app web dev, partagée par toutes les surfaces
 * (les builds `--mode dev` la sélectionnent via VITE_FIREBASE_ENV=dev).
 */
export const firebaseConfigDev: FirebaseWebConfig = {
  apiKey: 'AIzaSyDJOaU4PrPCQ6OaUkTiJd7YOejJ5Mje-dI',
  authDomain: 'hop-resto-dev-9ab2e.firebaseapp.com',
  projectId: 'hop-resto-dev',
  storageBucket: 'hop-resto-dev.firebasestorage.app',
  messagingSenderId: '817105162861',
  appId: '1:817105162861:web:0ff3e25d812a8ec2ae2564',
};

/** App web admin (back-office local). */
export const firebaseConfigAdmin: FirebaseWebConfig = {
  apiKey: 'AIzaSyBxOhpwYrDn0lJoNLMaarInGC2iKG-rWos',
  authDomain: 'hop-resto.firebaseapp.com',
  projectId: 'hop-resto',
  storageBucket: 'hop-resto.firebasestorage.app',
  messagingSenderId: '971760780175',
  appId: '1:971760780175:web:4a1dfb55f8560ba2ea41fa',
  measurementId: 'G-5CCXZ5W1ET',
};
